export const tableOption = {
  card: false,
  page: true,
  border: true,
  align: 'center',
  refreshBtn: true,
  emptyBtn: true,
  header: false, //表格头部中间菜单
  menu: true,
  addBtn: false, //新增按钮
  columnBtn: false,
  delBtn: false,
  editBtn: false,
  searchMenuSpan: 4,
  searchMenuPosition: 'left', //v2.7.9+
  menuWidth: 190,
  searchLabelWidth: 100,
  searchIcon: false,
  emptyText: '',
  column: [
    {
      label: '质控单号',
      prop: 'qcTaskId',
      searchLabelWidth: 150,
      slot: true,
    },
    {
      label: '任务类型',
      prop: 'isKit',
      searchLabelWidth: 80,
      hide: true,
      search: true,
      type: 'select',
      searchSpan: 4,
      searchValue: false,
      dicData: [
        {
          label: '质控任务',
          value: false,
        },
        {
          label: '质检任务',
          value: true,
        },
      ],
    },
    {
      label: '来源ID/订单号',
      prop: 'sourceId',
      searchLabelWidth: 120,
      hide: true,
      search: true,
      searchSpan: 6,
    },
    {
      label: '轻任务订单号',
      prop: 'orderId',
      width: 160,
    },
    {
      label: '来源ID',
      prop: 'sourceId',
    },
    {
      label: '订单领域',
      prop: 'fieldName',
      slot: true,
      width: 70,
      search: false,
    },
    {
      label: '派发人',
      prop: 'distributorName',
    },
    {
      label: '领取人',
      prop: 'receiveName',
      hide: true,
      search: false,
      searchLabelWidth: 70,
      searchSpan: 4,
    },
    {
      label: '订单类型',
      prop: 'qcOrderType',
      slot: true,
      width: 80,
    },
    {
      label: '语种方向',
      prop: 'lan',
      slot: true,
      width: 110,
      search: false,
    },
    {
      label: '预计任务金额',
      prop: 'amount',
      width: 130,
      slot: true,
      search: false,
      hide: false,
    },
    {
      label: '任务金额',
      prop: 'amount1',
      width: 130,
      slot: true,
      search: false,
      hide: true,
    },
    {
      label: '任务字数',
      prop: 'wordNum',
      width: 100,
      search: false,
    },
    {
      width: 140,
      label: '要求完成时间',
      prop: 'limitTime',
      type: 'datetime',
      sortable: 'custom',
      search: false,
      format: 'yyyy-MM-dd hh:mm:ss',
      valueFormat: 'timestamp',
    },
  ],
};

export const flowTaskOption = {
  align: 'center',
  refreshBtn: false,
  emptyBtn: true,
  header: false, //表格头部中间菜单
  page: true,
  menu: false,
  border: true,
  addBtn: false, //新增按钮
  columnBtn: false,
  delBtn: false,
  editBtn: false,
  menuWidth: 100,
  searchMenuSpan: 8,
  emptyText: '',
  column: [
    {
      label: '包编号',
      prop: 'packageNo',
      search: true,
      searchLabelWidth: 60,
      searchSize: 'small',
      searchSpan: 4,
      searchGutter: 10,
      width: 80,
    },
    {
      label: '最后审核人',
      prop: 'name',
      searchLabelWidth: 90,
      search: true,
      searchSize: 'small',
      searchGutter: 10,
      searchSpan: 4,
      width: 100,
      span: 10,
    },
    {
      label: 'lastReviewer',
      prop: 'lastReviewer',
      hide: true,
      span: 24,
    },
    {
      label: '提交时间',
      prop: 'submitTime',
      type: 'datetime',
      format: 'yyyy-MM-dd HH:mm',
      valueFormat: 'timestamp',
      width: 100,
      slot: true,
      span: 24,
    },
    {
      label: '风险程度',
      prop: 'riskLevel',
      width: 80,
      span: 24,
    },
    {
      label: '原文',
      prop: 'srcText',
      width: 270,
      span: 24,
    },
    {
      label: '机翻译文',
      prop: 'mtText',
      width: 270,
      slot: true,
      span: 24,
    },
    {
      label: '译文',
      prop: 'peText',
      width: 270,
      span: 24,
    },
    {
      label: '操作',
      prop: 'opera',
      slot: true,
      width: 120,
      span: 24,
    },
    {
      label: '质控结果',
      prop: 'taskStatus',
      slot: true,
      width: 80,
      span: 24,
    },
  ],
};

export const txtOption = {
  card: false,
  emptyBtn: false,
  refreshBtn: false,
  header: false, //表格头部中间菜单
  page: false,
  menu: true,
  addBtn: false, //新增按钮
  columnBtn: false,
  delBtn: false,
  editBtn: false,
  searchSpan: 24,
  searchMenuSpan: 10,
  menuWidth: 120,
  index: true,
  indexLabel: '序号',
  column: [
    {
      label: '句子ID',
      prop: 'sentId',
      hide: true,
    },
    {
      label: '原文',
      prop: 'srcText',
    },
    {
      label: '机翻译文',
      prop: 'mtText',
    },
    {
      label: 'PE译文',
      prop: 'peText',
      slot: true,
    },
  ],
};

//上下文
export const contextOption = {
  card: false,
  refreshBtn: false,
  header: false, //表格头部中间菜单
  page: false,
  menu: false,
  addBtn: false, //新增按钮
  columnBtn: false,
  delBtn: false,
  border: true,
  editBtn: false,
  column: [
    {
      label: '最后审核人',
      prop: 'name',
      slot: true,
    },
    {
      label: '原文',
      prop: 'srcText',
      slot: true,
    },
    // {
    //   label: '机翻译文',
    //   prop: 'mtText',
    //   slot: true,
    // },
    {
      label: '译文',
      prop: 'peText',
      width: 250,
      slot: true,
    },
    {
      label: '术语',
      prop: 'termInfoList',
      slot: true,
    },
    {
      label: '质控结果',
      prop: 'qcStatus',
      // width: 70,
      slot: true,
    },
    {
      width: 150,
      label: '操作',
      prop: 'control',
      slot: true,
    },
  ],
};

export const trackBackOption = {
  card: false,
  refreshBtn: false,
  header: false, //表格头部中间菜单
  page: false,
  menu: false,
  addBtn: false, //新增按钮
  columnBtn: false,
  delBtn: false,
  border: true,
  editBtn: false,
  column: [
    {
      label: '序号',
      prop: 'fileId',
      slot: true,
    },
    {
      label: '原文',
      prop: 'srcText',
      slot: true,
    },
    {
      label: '机翻译文',
      prop: 'mtText',
      slot: true,
    },
    {
      label: 'PE译文',
      prop: 'peText',
      slot: true,
    },
    {
      label: '质控结果',
      prop: 'qcStatus',
      slot: true,
    },
  ],
};

export const termOption = {
  card: false,
  refreshBtn: false,
  header: false, //表格头部中间菜单
  page: false,
  // menu: false,
  addBtn: false, //新增按钮
  // delBtn: false,
  border: true,
  editBtn: false,
  // maxHeight: '200',
  size: 'mini',
  column: [
    {
      label: '创建时间',
      prop: 'createTime',
    },
    {
      label: '原文',
      prop: 'srcText',
    },
    {
      label: '译文',
      prop: 'tranText',
    },
    {
      label: '创建人',
      prop: 'createUserName',
    },
    {
      label: '备注',
      prop: 'remark',
    },
    {
      label: 'id',
      prop: 'id',
      hide: true,
    },
    {
      label: 'orderId',
      prop: 'orderId',
      hide: true,
    },
    {
      label: 'oldTermId',
      prop: 'oldTermId',
      hide: true,
    },
    {
      label: 'termLibraryId',
      prop: 'termLibraryId',
      hide: true,
    },
  ],
};

export const termFormOption = {
  submitBtn: false,
  menuSpan: 24,
  column: [
    {
      labelWidth: 60,
      label: '原文',
      prop: 'srcText',
      type: 'textarea',
      maxlength: 200,
      showWordLimit: true,
      size: 'mini',
      span: 12,
      rules: [
        {
          required: true,
          message: '请输入原文',
          trigger: 'blur',
        },
      ],
    },
    {
      labelWidth: 60,
      label: '译文',
      prop: 'tranText',
      type: 'textarea',
      maxlength: 200,
      showWordLimit: true,
      size: 'mini',
      span: 12,
      rules: [
        {
          required: true,
          message: '请输入译文',
          trigger: 'blur',
        },
      ],
    },
    {
      labelWidth: 60,
      label: '备注',
      prop: 'remark',
      type: 'textarea',
      maxlength: 200,
      showWordLimit: true,
      size: 'mini',
      span: 24,
      rows: 1,
      rules: [
        {
          message: '请输入备注',
          trigger: 'blur',
        },
      ],
    },
  ],
};

export const termAuditOption = {
  page: true,
  menu: false,
  refreshBtn: false,
  emptyBtn: false,
  border: true,
  header: false, //表格头部中间菜单
  submitBtn: false,
  addBtn: false,
  viewBtn: false,
  editBtn: false,
  delBtn: false,
  viewTitle: '查看例句',
  viewBtnText: '查看例句',
  column: [
    {
      label: '原文',
      prop: 'srcText',
      type: 'textarea',
      maxlength: 200,
      showWordLimit: true,
      span: 9.5,
      rules: [
        {
          required: true,
          message: '请输入原文',
          trigger: 'blur',
        },
      ],
    },
    {
      label: '译文',
      prop: 'tranText',
      type: 'textarea',
      maxlength: 200,
      showWordLimit: true,
      span: 9.5,
      rules: [
        {
          required: true,
          message: '请输入译文',
          trigger: 'blur',
        },
      ],
    },
    {
      label: '备注',
      prop: 'remark',
      type: 'textarea',
      maxlength: 200,
      showWordLimit: true,
      span: 24,
      rules: [
        {
          message: '请输入备注',
          trigger: 'blur',
        },
      ],
    },
    {
      label: '创建者昵称',
      prop: 'createUserName',
      maxlength: 200,
      rules: [
        {
          required: true,
          message: '请输入译文',
          trigger: 'blur',
        },
      ],
    },
    {
      label: '操作',
      prop: 'checkStatus',
      slot: true,
      type: 'radio',
      dicData: [
        {
          label: '采纳',
          value: 2,
        },
        {
          label: '不采纳',
          value: 3,
        },
      ],
      rules: [
        {
          required: true,
          message: '请输入译文',
          trigger: 'blur',
        },
      ],
    },
    {
      label: '示例',
      prop: 'example',
      slot: true,
    },
  ],
};

export const qcFormOption = {
  submitBtn: false,
  column: [
    {
      labelWidth: 50,
      label: '',
      prop: 'remark',
      placeholder: '可以在此处给审核人员留言',
      type: 'textarea',
      maxlength: 800,
      span: 24,
      showWordLimit: true,
      row: true,
      rules: [
        {
          required: true,
          message: '请输入留言',
          trigger: 'blur',
        },
      ],
    },
  ],
};
